import { CanActivateFn } from '@angular/router';

import { stashAuthReturnUrl } from '@shared/utils';

/**
 * Remembers the attempted in-app URL before Auth0 or user bootstrap may
 * send the browser to `/loading`.
 */
export const stashAuthReturnUrlGuard: CanActivateFn = (_route, state) => {
  stashAuthReturnUrl(state.url);
  return true;
};
